import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};

export const CommissionApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCommission: builder.query<CommonResponseType & { data: any }, void>({
      query: () => ({
        url: `${END_POINTS.commission}`,
        method: "GET",
      }),
    }),
    updateCommissionId: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: CommonBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.commission}/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});
export const { useUpdateCommissionIdMutation, useLazyGetCommissionQuery } =
  CommissionApi;
